import { render, staticRenderFns } from "./TrendChart.vue?vue&type=template&id=6bddb054&"
import script from "./TrendChart.vue?vue&type=script&lang=js&"
export * from "./TrendChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bddb054')) {
      api.createRecord('6bddb054', component.options)
    } else {
      api.reload('6bddb054', component.options)
    }
    module.hot.accept("./TrendChart.vue?vue&type=template&id=6bddb054&", function () {
      api.rerender('6bddb054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/trending-charts/TrendChart.vue"
export default component.exports